import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-300">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center text-xl" aria-hidden="true">
                  <i className="ri-book-read-fill text-accent-500"></i>
                </span>
                <span className="text-lg font-heading text-background-50">土豪漫画</span>
              </div>
              <p className="text-sm leading-relaxed text-foreground-400">
                土豪漫画网 —— 海量韩漫、日漫、国漫分类大全，热门漫画一应俱全。全部免费在线阅读，下拉式流畅体验，让每位漫画爱好者都能找到心仪的作品。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/all" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">
                    全部分类
                  </Link>
                </li>
                <li>
                  <Link to="/category/韩漫" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">
                    韩漫专区
                  </Link>
                </li>
                <li>
                  <Link to="/category/日漫" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">
                    日漫专区
                  </Link>
                </li>
                <li>
                  <Link to="/category/国漫" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">
                    国漫专区
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">热门推荐</h4>
              <ul className="space-y-2">
                <li><Link to="/comic/1" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">我独自升级</Link></li>
                <li><Link to="/comic/10" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">鬼灭之刃</Link></li>
                <li><Link to="/comic/6" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">斗罗大陆</Link></li>
                <li><Link to="/comic/2" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">咒术回战</Link></li>
                <li><Link to="/comic/7" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">间谍过家家</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">关于我们</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">
                    品牌介绍
                  </Link>
                </li>
                <li><span className="text-sm text-foreground-400">联系邮箱：contact@tuhaomanhua.com</span></li>
                <li><span className="text-sm text-foreground-400">客服微信：tuhaomh888</span></li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="QQ" rel="nofollow">
                  <i className="ri-qq-line text-background-50 text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 土豪漫画网 tuhaomanhua.com — 本站所有漫画均来自网络，版权归原作者所有。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span>免责声明</span>
              <span>隐私政策</span>
              <Link to="/about" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="hover:text-accent-400 transition-colors">关于我们</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}